export default __webpack_public_path__ + "img/Image-404@1x.d0d07348885812837b1acec34c78deb7.png";